import { render, staticRenderFns } from "./VerifyShopDialog.vue?vue&type=template&id=90909f46&"
import script from "./VerifyShopDialog.vue?vue&type=script&lang=js&"
export * from "./VerifyShopDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VerifyShopDialog.vue"
export default component.exports